// removed by extract-text-webpack-plugin
module.exports = {"prefixIcon":"prefixIcon___1g3tv","submit":"submit___1Uso5","maskToggle":"maskToggle___dBD3S","passwordInput":"passwordInput___33Vtb"};